import { render, staticRenderFns } from "./RoomChatForm.vue?vue&type=template&id=0a69c08a&scoped=true&"
import script from "./RoomChatForm.vue?vue&type=script&lang=js&"
export * from "./RoomChatForm.vue?vue&type=script&lang=js&"
import style0 from "./RoomChatForm.vue?vue&type=style&index=0&id=0a69c08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a69c08a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a69c08a')) {
      api.createRecord('0a69c08a', component.options)
    } else {
      api.reload('0a69c08a', component.options)
    }
    module.hot.accept("./RoomChatForm.vue?vue&type=template&id=0a69c08a&scoped=true&", function () {
      api.rerender('0a69c08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Chat/RoomChatForm.vue"
export default component.exports